/**
 * PDP Gallery Navigator — Gymshark-style
 *
 * Nav is inside the scroller via a zero-width sticky wrapper.
 * CSS handles all positioning — JS never writes position props.
 * JS only: gradient painting on gallery scroll + stepped scroll.
 * No position:fixed. No rAF loop. No jitter. Moves with gallery as one unit.
 */
(function () {
  'use strict';

  var SCROLL_FRACTION = 0.25;
  var SMOOTH_DURATION = 320;
  var DESKTOP_BP      = 750;
  var TRACK_HEIGHT    = 100;

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn.bind(this), ms); };
  }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function smoothScroll(el, to, dur) {
    var from = el.scrollTop, dist = to - from, t0 = null;
    (function tick(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      el.scrollTop = from + dist * (1 - Math.pow(1 - p, 3));
      if (p < 1) requestAnimationFrame(tick);
    })(performance.now());
  }

  function init() {
    if (window.innerWidth < DESKTOP_BP) return;

    // This vertical scroll-nav belongs ONLY to the GRID gallery layout, where
    // the media column is a vertically-scrolling stack. The carousel, full and
    // partial layouts render a Swiper gallery (.swiper--product-gallery) and
    // must never show this nav. Bail for any non-grid layout and remove a nav
    // that a previous run (e.g. before a resize) may have inserted.
    var galleryEl = document.querySelector('[id^="MediaGallery-"][data-desktop-layout]');
    var layout = galleryEl && galleryEl.getAttribute('data-desktop-layout');
    if (layout !== 'product__media-layout--grid' || document.querySelector('.swiper--product-gallery')) {
      var stale = document.getElementById('pdp-gallery-nav-anchor');
      if (stale) stale.remove();
      return;
    }

    var grid = document.querySelector('.product-grid:not(.product-grid__has-no-media)');
    if (!grid) return;
    var mediaCol = grid.querySelector(':scope > .product-grid__item--media');
    if (!mediaCol) return;
    var scroller = mediaCol.querySelector('.product-grid__item--media-wrapper');
    if (!scroller) return;

    var old = document.getElementById('pdp-gallery-nav-anchor');
    if (old) old.remove();

    /* =================================================================
       BUILD: sticky anchor (zero-width, floated right, inside scroller)
       → nav (absolute, centered vertically in anchor)
       ================================================================= */
    var anchor = document.createElement('div');
    anchor.id = 'pdp-gallery-nav-anchor';

    var nav = document.createElement('div');
    nav.id = 'pdp-gallery-nav';

    nav.innerHTML =
      '<button data-dir="-1" style="' +
        'display:flex;align-items:center;justify-content:center;' +
        'width:34px;height:34px;min-height:34px;flex-shrink:0;' +
        'border-radius:50%;border:1px solid rgba(0,0,0,0.15);' +
        'background:rgba(255,255,255,0.92);backdrop-filter:blur(6px);' +
        'cursor:pointer;padding:0;' +
      '">' +
        '<svg viewBox="0 0 24 24" style="width:14px;height:14px;fill:none;stroke:#111;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;">' +
          '<polyline points="18 15 12 9 6 15"/>' +
        '</svg>' +
      '</button>' +
      '<div id="pdp-gallery-track" style="' +
        'display:block;box-sizing:border-box;' +
        'width:5px;min-width:5px;' +
        'height:' + TRACK_HEIGHT + 'px;min-height:' + TRACK_HEIGHT + 'px;' +
        'flex-shrink:0;flex-grow:0;flex-basis:' + TRACK_HEIGHT + 'px;' +
        'background:rgba(0,0,0,0.15);' +
        'border-radius:6px;cursor:pointer;' +
      '"></div>' +
      '<button data-dir="1" style="' +
        'display:flex;align-items:center;justify-content:center;' +
        'width:34px;height:34px;min-height:34px;flex-shrink:0;' +
        'border-radius:50%;border:1px solid rgba(0,0,0,0.15);' +
        'background:rgba(255,255,255,0.92);backdrop-filter:blur(6px);' +
        'cursor:pointer;padding:0;' +
      '">' +
        '<svg viewBox="0 0 24 24" style="width:14px;height:14px;fill:none;stroke:#111;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;">' +
          '<polyline points="6 9 12 15 18 9"/>' +
        '</svg>' +
      '</button>';

    anchor.appendChild(nav);
    scroller.insertBefore(anchor, scroller.firstChild);

    var track     = document.getElementById('pdp-gallery-track');
    var arrows    = nav.querySelectorAll('button');
    var arrowUp   = arrows[0];
    var arrowDown = arrows[1];

    /* =================================================================
       TRACK GRADIENT — only fires on gallery scroll
       ================================================================= */
    function paintTrack() {
      var sH  = scroller.scrollHeight;
      var cH  = scroller.clientHeight;
      var sT  = scroller.scrollTop;
      var max = sH - cH;

      if (max <= 10) {
        nav.style.display = 'none';
        return;
      }
      nav.style.display = 'flex';

      var ratio     = clamp(cH / sH, 0.12, 0.85);
      var knobPct   = Math.max(ratio * 100, 15);
      var posFrac   = sT / max;
      var topPct    = posFrac * (100 - knobPct);
      var bottomPct = topPct + knobPct;

      track.style.background =
        'linear-gradient(to bottom,' +
          'rgba(0,0,0,0.15) ' + topPct.toFixed(1) + '%,' +
          '#000 ' + topPct.toFixed(1) + '%,' +
          '#000 ' + bottomPct.toFixed(1) + '%,' +
          'rgba(0,0,0,0.15) ' + bottomPct.toFixed(1) + '%)';

      arrowUp.style.opacity = sT <= 3 ? '0.2' : '1';
      arrowUp.style.pointerEvents = sT <= 3 ? 'none' : 'auto';
      arrowDown.style.opacity = sT >= max - 3 ? '0.2' : '1';
      arrowDown.style.pointerEvents = sT >= max - 3 ? 'none' : 'auto';
    }

    scroller.addEventListener('scroll', paintTrack, { passive: true });

    /* === Stepped scroll =================================================== */
    function scrollStep(dir) {
      var max = scroller.scrollHeight - scroller.clientHeight;
      if (max <= 0) return;
      var step = Math.round(scroller.clientHeight * SCROLL_FRACTION);
      smoothScroll(scroller, clamp(scroller.scrollTop + step * dir, 0, max), SMOOTH_DURATION);
    }

    /* Arrow hold-to-repeat: fires once on press, then repeats while held */
    function setupArrow(btn, dir) {
      var holdTimer = null;
      var holdInterval = null;

      function start(e) {
        e.preventDefault();
        scrollStep(dir);
        holdTimer = setTimeout(function () {
          holdInterval = setInterval(function () {
            scrollStep(dir);
          }, 180);
        }, 400);
      }

      function stop() {
        clearTimeout(holdTimer);
        clearInterval(holdInterval);
        holdTimer = null;
        holdInterval = null;
      }

      btn.addEventListener('mousedown', start);
      btn.addEventListener('touchstart', start, { passive: false });
      window.addEventListener('mouseup', stop);
      window.addEventListener('touchend', stop);
      btn.addEventListener('mouseleave', stop);
    }

    setupArrow(arrowUp, -1);
    setupArrow(arrowDown, 1);

    /* Wheel */
    scroller.addEventListener('wheel', function (e) {
      var max = scroller.scrollHeight - scroller.clientHeight;
      if (max <= 0) return;
      if (scroller.scrollTop <= 0 && e.deltaY < 0) return;
      if (scroller.scrollTop >= max - 1 && e.deltaY > 0) return;
      e.preventDefault();
      e.stopPropagation();
      scrollStep(e.deltaY > 0 ? 1 : -1);
    }, { passive: false });

    /* Track click */
    track.addEventListener('click', function (e) {
      var frac = (e.clientY - track.getBoundingClientRect().top) / TRACK_HEIGHT;
      var max = scroller.scrollHeight - scroller.clientHeight;
      smoothScroll(scroller, clamp(Math.round(frac * max), 0, max), SMOOTH_DURATION);
    });

    /* === Resize ========================================================== */
    window.addEventListener('resize', debounce(function () {
      if (window.innerWidth < DESKTOP_BP) { nav.style.display = 'none'; return; }
      paintTrack();
    }, 150));

    /* Observer */
    new MutationObserver(debounce(paintTrack, 100))
      .observe(scroller, { childList: true, subtree: true, attributes: true });

    /* Image loading + polling */
    function watchImgs() {
      scroller.querySelectorAll('img').forEach(function (i) {
        if (!i.complete) i.addEventListener('load', paintTrack, { once: true });
      });
    }
    watchImgs();
    var n = 0, poll = setInterval(function () {
      n++; paintTrack(); watchImgs();
      if (n >= 25) clearInterval(poll);
    }, 250);

    paintTrack();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.product-grid')) setTimeout(init, 150);
  });
})();
